import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

let _ = t => t,
    _t;

import styled, { createGlobalStyle } from 'styled-components';
import UIImage from 'UIComponents/image/UIImage';
import UIDialogFooter from 'UIComponents/dialog/UIDialogFooter';
import UIDialogHeader from 'UIComponents/dialog/UIDialogHeader';
import UIFlex from 'UIComponents/layout/UIFlex';
import UIModal from 'UIComponents/dialog/UIModal';
import H3 from 'UIComponents/elements/headings/H3';
import OnboardingTourButtons from '../OnboardingTourButtons';
import Confetti from '../Confetti';
// Hide the banner from modals and show it only after the user action on the modal CTA.
const HandholdingBannerGlobalStyle = createGlobalStyle(_t || (_t = _`
  .uiFullScreenBackground #onboarding-tours-banner-frame {
    filter: blur(5px);
    z-index: auto !important
  }
`));
const ModalContentWrapper = styled.div.withConfig({
  displayName: "OnboardingTourImageModal__ModalContentWrapper",
  componentId: "dbmpvp-0"
})(["margin:0 auto 0 auto;max-width:660px;@media (max-height:650px){max-width:580px;}@media (max-height:690px){margin-top:30px;}"]);
const LargerText = styled.div.withConfig({
  displayName: "OnboardingTourImageModal__LargerText",
  componentId: "dbmpvp-1"
})(["font-size:16px;"]);

const OnboardingTourModal = props => {
  const {
    step: {
      title,
      text,
      buttons,
      image,
      modal
    }
  } = props,
        rest = _objectWithoutPropertiesLoose(props, ["step"]);

  const modalProps = modal !== undefined && typeof modal !== 'boolean' ? modal : {};
  const {
    showConfetti
  } = modalProps;
  return /*#__PURE__*/_jsxs(UIModal, Object.assign({}, rest, {
    className: "m-top-0",
    use: "conversational",
    width: 788,
    children: [showConfetti && /*#__PURE__*/_jsx(Confetti, {
      widthPercentage: 300
    }), /*#__PURE__*/_jsxs(ModalContentWrapper, {
      children: [/*#__PURE__*/_jsx(UIDialogHeader, {
        className: "text-center",
        children: /*#__PURE__*/_jsx(H3, {
          children: title
        })
      }), /*#__PURE__*/_jsxs("div", {
        className: "p-top-6 p-bottom-6 text-center",
        children: [/*#__PURE__*/_jsx(LargerText, {
          children: text
        }), image && /*#__PURE__*/_jsx(UIFlex, {
          justify: "center",
          children: /*#__PURE__*/_jsx(UIImage, {
            alt: image.alt,
            className: "m-top-6",
            src: image.src,
            width: image.width
          })
        })]
      }), /*#__PURE__*/_jsx(UIDialogFooter, {
        align: "center",
        className: "p-left-0 p-right-0",
        children: /*#__PURE__*/_jsx(OnboardingTourButtons, {
          buttons: buttons || []
        })
      }), /*#__PURE__*/_jsx(HandholdingBannerGlobalStyle, {})]
    })]
  }));
};

export default OnboardingTourModal;